import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "../locales/en-US/paymentshub.json";
import de from "../locales/de-DE/paymentshub.json";
import es from "../locales/es-ES/paymentshub.json";
import fr from "../locales/fr-FR/paymentshub.json";
import it from "../locales/it-IT/paymentshub.json";
import ptbr from "../locales/pt-BR/paymentshub.json";

export const initTranslations = (): void => {
  void i18next
    .use(initReactI18next)
    .use(LanguageDetector)
    .init({
      fallbackLng: "en",
      lowerCaseLng: true,
      resources: {
        en: {
          translation: en,
        },
        de: {
          translation: de,
        },
        es: {
          translation: es,
        },
        fr: {
          translation: fr,
        },
        it: {
          translation: it,
        },
        "pt-br": {
          translation: ptbr,
        },
      },
    });
};
